import { Reducer } from 'redux';
import { OcorrenciaState, OcorrenciaTypes } from './types';

const INITIAL_STATE: OcorrenciaState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<OcorrenciaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OcorrenciaTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OcorrenciaTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
        pagination: action.payload.pagination,
      };
    case OcorrenciaTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case OcorrenciaTypes.LOAD_REQUEST_UPDATE:
      return {
        ...state,
        loading: true,
      };
    case OcorrenciaTypes.LOAD_SUCCESS_UPDATE:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case OcorrenciaTypes.LOAD_FAILURE_UPDATE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
